import { Injectable, Input } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { RepEditorStateService } from '../rep-editor-state.service'

@Injectable()
export abstract class GridEditorBaseComponent<T = any> {
  @Input() repId: number
  public formGroup: UntypedFormGroup
  protected editedRowIndex: number

  protected typesService: TypesServices
  protected clientService: ClientServices
  protected formBuilder: UntypedFormBuilder
  public repState: RepEditorStateService

  constructor(
    _typesService: TypesServices,
    _clientService: ClientServices,
    _formBuilder: UntypedFormBuilder,
    _repEditorStateService: RepEditorStateService,
  ) {
    this.typesService = _typesService
    this.clientService = _clientService
    this.formBuilder = _formBuilder
    this.repState = _repEditorStateService
  }

  public checkGridState() {
    if (this.repState.repId !== this.repId) {
      this.repState.clearRepState()
      this.repState.repId = this.repId
    }
  }

  public addHandlerShared({ sender }, gridItem) {
    this.closeEditor(sender)
    this.formGroup = this.createFormGroup(gridItem)
    sender.addRow(this.formGroup)
  }

  public editHandler({ sender, rowIndex, dataItem }) {
    this.closeEditor(sender)
    this.formGroup = this.createFormGroup(dataItem)
    this.editedRowIndex = rowIndex
    sender.editRow(rowIndex, this.formGroup)
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex)
  }

  public closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex)
    this.editedRowIndex = null
    this.formGroup = null
  }

  abstract saveHandler({ sender, rowIndex, formGroup, isNew }): void
  abstract initGrid(): void
  abstract addHandler({ sender })
  abstract removeHandler({ dataItem })
  abstract createFormGroup(editItem: T): UntypedFormGroup
}
